export default {
  categoryOptions: [],
};
